module.exports = __webpack_public_path__ + "img/logo_sail.b8567237.png";